// randomNumber.js
let randomNumber = null;

export const getRandomNumber = () => {
  if (randomNumber === null) {
    randomNumber = Math.floor(Math.random() * (20 - 5 + 1)) + 5;
  }
  return randomNumber;
};
